<ion-header>
  <ion-toolbar>
    <ion-title>
      <ion-row class="ion-align-items-center ion-padding-top ion-justify-content-between">
        <app-logo class="logo"></app-logo>
        <small>&copy; {{ currentYear }} ME Fit B.V.</small>
      </ion-row>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">



  <ion-row *ngIf="loading$ | async" class="ion-justify-content-center ion-align-items-center ion-padding">
    <ion-spinner></ion-spinner>
  </ion-row>

  <ion-row *ngIf="error$ | async" class="ion-justify-content-center ion-align-items-center ion-padding">
    <p>{{ 'onboarding.workout.builder.load.fail' | translate }}</p>
  </ion-row>

  <main *ngIf="ready$ | async" class="builder-shell">
    <h2>{{ 'onboarding.workout.builder.title' | translate }}</h2>
    <p>{{ 'onboarding.workout.builder.message' | translate }}</p>
    <form [formGroup]="workoutForm">
      <ion-item fill="outline">
        <ion-label position="floating">{{ 'workout.name' | translate }}</ion-label>
        <ion-input type="text" formControlName="name"></ion-input>
        <ion-note slot="error" *ngIf="workoutForm.controls.name.touched && workoutForm.controls.name.hasError('required')">
          {{ 'is.required' | translate: { fieldName: ('workout.name' | translate) } }}
        </ion-note>
      </ion-item>

      <ion-item fill="outline" class="ion-margin-top">
        <ion-label position="floating">{{ 'workout.description' | translate }}</ion-label>
        <ion-textarea formControlName="description"></ion-textarea>
      </ion-item>
    </form>

    <app-workout
      class="ion-margin-top"
      [anonymous]="true">
    </app-workout>
  </main>
</ion-content>

<ion-footer *ngIf="ready$ | async" class="ion-padding">
  <ion-row class="ion-justify-content-end">
    <ion-button class="onboarding-finish-button" color="secondary" (click)="openCompletionModal()">
      {{ 'onboarding.workout.builder.finish' | translate }}
    </ion-button>
  </ion-row>
</ion-footer>

<ion-modal #completionModal (didDismiss)="dismissCompletionModal()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'onboarding.workout.builder.modal.title' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="dismissCompletionModal()" [attr.aria-label]="'action.close' | translate">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <img class="sharing-illustration ion-hide-sm-down" src="assets/homescreen-illustration.webp" [alt]="'mefit.pro.title' | translate">
      <img class="sharing-illustration ion-hide-sm-up" src="assets/homescreen-illustration-mobile.png" [alt]="'mefit.pro.title' | translate">
      <p>{{ 'onboarding.workout.builder.modal.message' | translate }}</p>
    </ion-content>
    <ion-footer class="ion-padding">
      <ion-button expand="block" color="secondary" (click)="continueToOnboarding()">
        {{ 'onboarding.workout.builder.continue' | translate }}
      </ion-button>
      <ion-button expand="block" fill="outline" class="ion-margin-top" (click)="printWorkout()">
        {{ 'workout.print' | translate }}
      </ion-button>
    </ion-footer>
  </ng-template>
</ion-modal>
